import React from "react";
import {RadioInput, TextInput} from "../../../components";
import FormField from "../../../components/form/FormField";
import SignatureInput from "../../../components/signature-input/SignatureInput";
import InformedConsentFormRadTextEnum from "../informedconsent/enum/InformedConsentFormRadTextEnum";

const Title = (props) => {
    const {selectedLanguage} = props;

    return (
        <>
            <h2>{InformedConsentFormRadTextEnum.Informed_Consent[selectedLanguage]}</h2>
        </>
    )
}

const RadiologyProcedureConsent = (props) => {
    const {selectedLanguage} = props;

    return (
        <>
            <p className="font-weight-bold">{InformedConsentFormRadTextEnum.Radiology_Procedure_Consent_Title[selectedLanguage]}</p>
            <p>{InformedConsentFormRadTextEnum.Radiology_Procedure_Paragraph_1[selectedLanguage]}</p>
            <ul>
                <li>{InformedConsentFormRadTextEnum.Radiology_Procedure_Point_1[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Radiology_Procedure_Point_2[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Radiology_Procedure_Point_3[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Radiology_Procedure_Point_4[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Radiology_Procedure_Point_5[selectedLanguage]}</li>
            </ul>
        </>
    )
}

const RadiationRiskDeclaration = (props) => {
    const {selectedLanguage, onChange, pregnancyStatus, readOnly, pushFormFieldRef} = props;

    return (
        <>
            <p className="font-weight-bold">{InformedConsentFormRadTextEnum.Radiation_Risk_Pregnancy_Title[selectedLanguage]}</p>
            
            <p className="font-weight-bold mt-3">{InformedConsentFormRadTextEnum.Acknowledgement_Radiation_Pregnancy_Title[selectedLanguage]}</p>
            
            <p>{InformedConsentFormRadTextEnum.Radiation_Risk_Paragraph_1[selectedLanguage]}</p>
            
            <ul className="mt-3">
                <li>{InformedConsentFormRadTextEnum.Radiation_Understanding_Point_1[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Radiation_Understanding_Point_2[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Radiation_Understanding_Point_3[selectedLanguage]}</li>
            </ul>
            
            <div className="mt-3">
                <p className="font-weight-bold">{InformedConsentFormRadTextEnum.Pregnancy_Declaration_Options[selectedLanguage]}</p>
                
                <FormField 
                    required 
                    requiredMessage="Pregnancy status is required"
                    validateOn={pregnancyStatus}
                    ref={ref => pushFormFieldRef && pushFormFieldRef(ref)}
                >
                    <div>
                        <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                name="pregnancyStatus" 
                                id="not-pregnant"
                                value="NOT_PREGNANT"
                                checked={pregnancyStatus === "NOT_PREGNANT"}
                                onChange={(e) => onChange && onChange("pregnancyStatus", e.target.value)}
                                disabled={readOnly}
                                style={{position: 'static', marginLeft: '0', marginRight: '10px'}}
                            />
                            <label className="form-check-label" htmlFor="not-pregnant" style={{marginBottom: '0'}}>
                                {InformedConsentFormRadTextEnum.Pregnancy_Option_1[selectedLanguage]}
                            </label>
                        </div>
                        
                        <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                name="pregnancyStatus" 
                                id="pregnant"
                                value="PREGNANT"
                                checked={pregnancyStatus === "PREGNANT"}
                                onChange={(e) => onChange && onChange("pregnancyStatus", e.target.value)}
                                disabled={readOnly}
                                style={{position: 'static', marginLeft: '0', marginRight: '10px'}}
                            />
                            <label className="form-check-label" htmlFor="pregnant" style={{marginBottom: '0'}}>
                                {InformedConsentFormRadTextEnum.Pregnancy_Option_2[selectedLanguage]}
                            </label>
                        </div>
                        
                        <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                name="pregnancyStatus" 
                                id="unsure"
                                value="UNSURE"
                                checked={pregnancyStatus === "UNSURE"}
                                onChange={(e) => onChange && onChange("pregnancyStatus", e.target.value)}
                                disabled={readOnly}
                                style={{position: 'static', marginLeft: '0', marginRight: '10px'}}
                            />
                            <label className="form-check-label" htmlFor="unsure" style={{marginBottom: '0'}}>
                                {InformedConsentFormRadTextEnum.Pregnancy_Option_3[selectedLanguage]}
                            </label>
                        </div>
                        
                        <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                name="pregnancyStatus" 
                                id="na"
                                value="NA"
                                checked={pregnancyStatus === "NA"}
                                onChange={(e) => onChange && onChange("pregnancyStatus", e.target.value)}
                                disabled={readOnly}
                                style={{position: 'static', marginLeft: '0', marginRight: '10px'}}
                            />
                            <label className="form-check-label" htmlFor="na" style={{marginBottom: '0'}}>
                                {InformedConsentFormRadTextEnum.Pregnancy_Option_4[selectedLanguage]}
                            </label>
                        </div>
                    </div>
                </FormField>
            </div>
            
            <div className="mt-4">
                <p>{InformedConsentFormRadTextEnum.Voluntary_Consent_Paragraph[selectedLanguage]}</p>
            </div>
        </>
    )
}

const ModalityTypeSelection = (props) => {
    const {selectedLanguage, onChange, modalityType, readOnly, pushFormFieldRef} = props;

    return (
        <>
            <p className="font-weight-bold mt-3">{InformedConsentFormRadTextEnum.Type_Of_Modality_Title[selectedLanguage]}</p>

            <FormField
                required
                requiredMessage="Modality type is required"
                validateOn={modalityType}
                ref={ref => pushFormFieldRef && pushFormFieldRef(ref)}
            >
                <div>
                    <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                        <input
                            className="form-check-input"
                            type="radio"
                            name="modalityType"
                            id="x-ray"
                            value="X_RAY"
                            checked={modalityType === "X_RAY"}
                            onChange={(e) => onChange && onChange("modalityType", e.target.value)}
                            disabled={readOnly}
                            style={{position: 'static', marginLeft: '0', marginRight: '10px'}}
                        />
                        <label className="form-check-label" htmlFor="x-ray" style={{marginBottom: '0'}}>
                            {InformedConsentFormRadTextEnum.Modality_Option_X_Ray[selectedLanguage]}
                        </label>
                    </div>

                    <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                        <input
                            className="form-check-input"
                            type="radio"
                            name="modalityType"
                            id="ultrasound"
                            value="ULTRASOUND"
                            checked={modalityType === "ULTRASOUND"}
                            onChange={(e) => onChange && onChange("modalityType", e.target.value)}
                            disabled={readOnly}
                            style={{position: 'static', marginLeft: '0', marginRight: '10px'}}
                        />
                        <label className="form-check-label" htmlFor="ultrasound" style={{marginBottom: '0'}}>
                            {InformedConsentFormRadTextEnum.Modality_Option_Ultrasound[selectedLanguage]}
                        </label>
                    </div>

                    <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                        <input
                            className="form-check-input"
                            type="radio"
                            name="modalityType"
                            id="dexa"
                            value="DEXA"
                            checked={modalityType === "DEXA"}
                            onChange={(e) => onChange && onChange("modalityType", e.target.value)}
                            disabled={readOnly}
                            style={{position: 'static', marginLeft: '0', marginRight: '10px'}}
                        />
                        <label className="form-check-label" htmlFor="dexa" style={{marginBottom: '0'}}>
                            {InformedConsentFormRadTextEnum.Modality_Option_DEXA[selectedLanguage]}
                        </label>
                    </div>
                </div>
            </FormField>
        </>
    )
}

const RemoteRadiologyConsent = (props) => {
    const {selectedLanguage} = props;

    return (
        <>
            <p className="font-weight-bold">{InformedConsentFormRadTextEnum.Remote_Radiology_Title[selectedLanguage]}</p>
            <p>{InformedConsentFormRadTextEnum.Remote_Radiology_Paragraph_1[selectedLanguage]}</p>
            <ul>
                <li>{InformedConsentFormRadTextEnum.Remote_Radiology_Paragraph_2[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Remote_Radiology_Paragraph_3[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Remote_Radiology_Paragraph_4[selectedLanguage]}</li>
            </ul>
        </>
    )
}

const DataCollectionAndPrivacy = (props) => {
    const {selectedLanguage} = props;

    return (
        <>
            <p className="font-weight-bold">{InformedConsentFormRadTextEnum.Data_Collection_Privacy_Title[selectedLanguage]}</p>
            <p>{InformedConsentFormRadTextEnum.Data_Collection_Paragraph_1[selectedLanguage]}</p>
            <p>{InformedConsentFormRadTextEnum.Data_Collection_Paragraph_2[selectedLanguage]}</p>
            
            <div className="mt-4">
                <p className="font-weight-bold">{InformedConsentFormRadTextEnum.Data_Protection_Title[selectedLanguage]}</p>
                <ul>
                    <li>{InformedConsentFormRadTextEnum.Data_Protection_Step_1[selectedLanguage]}</li>
                    <li>{InformedConsentFormRadTextEnum.Data_Protection_Step_2[selectedLanguage]}</li>
                    <li>{InformedConsentFormRadTextEnum.Data_Protection_Step_3[selectedLanguage]}</li>
                    <li>{InformedConsentFormRadTextEnum.Data_Protection_Step_4[selectedLanguage]}</li>
                    <li>{InformedConsentFormRadTextEnum.Data_Protection_Step_5[selectedLanguage]}</li>
                </ul>
            </div>
            
            <div className="mt-3">
                <p>{InformedConsentFormRadTextEnum.Data_Disclaimer_1[selectedLanguage]}</p>
                <p>{InformedConsentFormRadTextEnum.Data_Disclaimer_2[selectedLanguage]}</p>
            </div>
        </>
    )
}

const PatientRights = (props) => {
    const {selectedLanguage} = props;

    return (
        <>
            <p className="font-weight-bold">{InformedConsentFormRadTextEnum.Patient_Rights_Title[selectedLanguage]}</p>
            <ul>
                <li>{InformedConsentFormRadTextEnum.Patient_Rights_Item_1[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Patient_Rights_Item_2[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Patient_Rights_Item_3[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Patient_Rights_Item_4[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Patient_Rights_Item_5[selectedLanguage]}</li>
                <li>{InformedConsentFormRadTextEnum.Patient_Rights_Item_6[selectedLanguage]}</li>
            </ul>
        </>
    )
}

const QuestionsAndConcerns = (props) => {
    const {selectedLanguage} = props;

    return (
        <>
            <p className="font-weight-bold">{InformedConsentFormRadTextEnum.Questions_Concerns_Title[selectedLanguage]}</p>
            <p>{InformedConsentFormRadTextEnum.Questions_Concerns_Paragraph[selectedLanguage]}</p>
        </>
    )
}

const Complaints = (props) => {
    const {selectedLanguage} = props;

    return (
        <>
            <p className="font-weight-bold">{InformedConsentFormRadTextEnum.Complaints_Title[selectedLanguage]}</p>
            <p>{InformedConsentFormRadTextEnum.Complaints_Paragraph[selectedLanguage]}</p>
        </>
    )
}

const FinalConsent = (props) => {
    const {selectedLanguage} = props;

    return (
        <>
            <p>{InformedConsentFormRadTextEnum.Final_Consent_Paragraph_1[selectedLanguage]}</p>
            <p>{InformedConsentFormRadTextEnum.Final_Consent_Paragraph_2[selectedLanguage]}</p>
            <p>{InformedConsentFormRadTextEnum.Final_Consent_Paragraph_3[selectedLanguage]}</p>
        </>
    )
}

const HealthcareProviderGenderAcknowledgment = (props) => {
    const {selectedLanguage, genderAcknowledgment,  onGenderAcknowledgmentChange, readOnly, pushFormFieldRef} = props;

    const yesNoOptions = [
        {key: true, value: InformedConsentFormRadTextEnum.Yes[selectedLanguage]},
        {key: false, value: InformedConsentFormRadTextEnum.No[selectedLanguage]}
    ];

    const handleRadioChange = (value) => {
        if (value === null && genderAcknowledgment !== null) {
            return;
        }
        const booleanValue = value === "true";
        onGenderAcknowledgmentChange && onGenderAcknowledgmentChange(booleanValue);
    };

    return (
        <>
            <div className="mt-4">
                <p className="font-weight-bold">{InformedConsentFormRadTextEnum.Healthcare_Provider_Gender_Title[selectedLanguage]}</p>
                
                <div className="mb-3">
                    <p>{InformedConsentFormRadTextEnum.Healthcare_Provider_Gender_Statement[selectedLanguage]}</p>
                    <p>{InformedConsentFormRadTextEnum.Healthcare_Provider_Permission_Statement[selectedLanguage]}</p>
                </div>

                <div className="row mt-3">
                    <div className="col-md-12">
                        <FormField 
                            required 
                            requiredMessage="Gender acknowledgment is required"
                            validateOn={genderAcknowledgment}
                            ref={ref => pushFormFieldRef && pushFormFieldRef(ref)}
                        >
                            <RadioInput
                                id="genderAcknowledgmentRadio"
                                value={genderAcknowledgment != null ? genderAcknowledgment.toString() : null}
                                disabled={readOnly}
                                options={yesNoOptions}
                                displayProperty="value"
                                valueProperty="key"
                                onChange={handleRadioChange}
                            />
                        </FormField>
                    </div>
                </div>
            </div>
        </>
    )
}

const WitnessStatement = (props) => {
    const {selectedLanguage, consentDate, witnessName, witnessSignature, onWitnessNameChange, onWitnessSignatureChange, readOnly, formFields, pushFormFieldRef} = props;

    return (
        <>
            <div className="mt-4 pt-3" style={{borderTop: "2px solid #ddd"}}>
                <div className={"row"} style={{margin: "10px 15px"}}>
                    <div className="col-md-12">
                        <p className="font-weight-bold">
                            <u>{'FOR OFFICIAL USE ONLY'}</u>
                        </p>
                        <p className="font-weight-bold">
                            {InformedConsentFormRadTextEnum.Witness_Statement_Title[selectedLanguage]}
                        </p>
                        <p style={{fontStyle: "italic"}}>
                            {InformedConsentFormRadTextEnum.Witness_Statement_Text[selectedLanguage]}
                        </p>
                    </div>
                </div>

                <div className="row" style={{margin: "10px 15px"}}>
                    <div className="col-md-6 dim14-form-label">
                        Date
                    </div>
                    <div className="col-md-6 dim14-base-input text-center">
                        {consentDate}
                    </div>
                    <div className="col-md-6 dim14-form-label">
                        Witness Name
                    </div>
                    <div className="col-md-6 dim14-base-input">
                        <FormField validateOn={witnessName}
                                   ref={ref => pushFormFieldRef && pushFormFieldRef(ref)}>
                            <TextInput 
                                value={witnessName || ""} 
                                disabled={readOnly} 
                                alphabeticOnly 
                                style={{textAlign: "center"}}
                                onChange={(val) => onWitnessNameChange && onWitnessNameChange(val)}
                            />
                        </FormField>
                    </div>
                    <div className="col-md-6 dim14-form-label">
                        Witness Signature
                    </div>
                    <div className="col-md-6">
                        <FormField validateOn={witnessSignature}
                                   ref={ref => pushFormFieldRef && pushFormFieldRef(ref)}>
                            <SignatureInput
                                signature={witnessSignature || ""}
                                onSave={onWitnessSignatureChange} 
                                readOnly={readOnly}
                            />
                        </FormField>
                    </div>
                </div>
            </div>
        </>
    )
}

export default {
    Title,
    RadiologyProcedureConsent,
    RadiationRiskDeclaration,
    ModalityTypeSelection,
    RemoteRadiologyConsent,
    DataCollectionAndPrivacy,
    PatientRights,
    QuestionsAndConcerns,
    Complaints,
    FinalConsent,
    HealthcareProviderGenderAcknowledgment,
    WitnessStatement
};